export function getLayout(
    isNewLine,
    labelSpan,
    labelOffset,
    wrapperSpan,
    wrapperOffset
) {
    const labelAlign = isNewLine === 'true'?  'left': 'right';
    const itemLayout = isNewLine === 'true' ?
        {
            labelCol: {span: 22, offset: 2},
            wrapperCol: {span: 22, offset: 2},
            labelAlign
        }
        :
        {
            labelCol: {span: labelSpan, offset: labelOffset},
            wrapperCol: {span: wrapperSpan, offset: wrapperOffset},
            labelAlign
        } ;

    return itemLayout;
}